import createVueComponent from '../createVueComponent';

const Edit3 = createVueComponent('Edit3Icon', [
  ['path', { d: 'M12 20h9' }],
  ['path', { d: 'M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z' }],
]);

export default Edit3;
